export default "__VITE_ASSET__C5Qyg9FF__"